import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import { colors, sizes } from '@lmc/common/constants'
import Operations from '../../../operations'
import { Spinner, Sidebar, TabBar } from '../../../components/generic'
import theme from '../../../LEGACY/theme'
import { Outlet } from 'react-router-dom'
import { withRouter } from '../../../withRouter'

export class HomeScreen extends Component {
  componentDidMount() {
    const { fetchLists } = this.props
    fetchLists()
  }

  formatHomes = (homes) =>
    _(homes)
      .orderBy('name')
      .map((home) => ({
        ...home,
        name: { first: home?.name, last: '' },
      }))
      .value()

  render() {
    const {
      homes,
      location,
      router: { params },
    } = this.props
    if (!homes) return <Spinner />

    return (
      <div style={styles.mainContainer}>
        <div style={styles.leftContainer}>
          <Sidebar
            hideCreateButton
            title="Sites"
            filterId="homes"
            screenId="homes"
            placeholderPicture="https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/house_placeholder.png"
            items={this.formatHomes(homes)}
            params={params}
            style={styles.sidebar}
          />
        </div>
        <div style={styles.rightContainer}>
          <TabBar
            location={location}
            items={[
              { label: 'Profile', url: 'profile', octicon: 'person' },
              { label: 'Charts', url: 'dashboard', octicon: 'graph' },
            ]}
            resourceId={params.id}
            resourceUrl="homes"
            style={styles.desktopNav}
          />
          <div style={styles.childContainer}>
            <div style={styles.childWidth}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  backLink: {
    paddingLeft: 0,
    paddingRight: 0,
    position: 'relative',
    bottom: 40,
    right: 10,
  },
  childContainer: {
    overflowY: 'auto',
    height: '86vh',
    width: '100%',
    padding: '0px 20px',
  },
  childWidth: {
    margin: '0 auto',
    height: '100%',
  },
  desktopNav: {
    minWidth: 800,
  },
  leftContainer: {
    minWidth: sizes.minLeftPanel,
    width: sizes.leftPanel,
    zIndex: '3',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: theme.container.size.large,
    margin: '0 auto',
  },
  mobileBackLink: {
    paddingLeft: 0,
    paddingRight: 0,
    position: 'relative',
    bottom: 10,
    right: 10,
  },
  mobileChildContainer: {
    overflowY: 'auto',
    height: '88vh',
    width: '100%',
    padding: '10px 20px 0px 20px',
  },
  mobileContainer: {
    background: colors.background,
    minWidth: 0,
    wordWrap: 'break-word',
  },
  rightContainer: {
    background: colors.background,
    wordWrap: 'break-word',
    width: sizes.rightPanel,
    minWidth: sizes.minRightPanel,
  },
  sidebar: {
    height: '92vh',
  },
  noResidentsMessage: {
    padding: 60,
    marginTop: 50,
    maxWidth: 1000,
  },
}

HomeScreen.propTypes = {
  children: PropTypes.node.isRequired,
  fetchLists: PropTypes.func.isRequired,
  homes: PropTypes.array,
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => {
  return {
    homes: state.data.homes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLists: () => {
      dispatch(Operations.loadList('homes'))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HomeScreen))
